import Pattern from '@/assets/pattern.svg'

export function KPICard({
  title,
  value,
  description,
}: {
  title: string
  value: string
  description: string
}) {
  return (
    <div className="bg-primary-950 relative h-full w-full rounded-lg text-white gap-x-16 gap-y-8 p-8">
      <div
        className="absolute inset-0 z-0 bg-cover bg-center opacity-15"
        style={{ backgroundImage: `url(${Pattern})` }}
      />
      <div className="relative z-10 h-full w-full flex flex-col-reverse justify-between">
        <p className="flex-none text-5xl font-bold tracking-tight text-white">{value}</p>
        <div className="sm:shrink lg:w-auto lg:flex-none">
          <p className="text-lg font-semibold tracking-tight text-white">{title}</p>
          <p className="mt-2 text-base/7 text-gray-300 text-pretty">{description}</p>
        </div>
      </div>
    </div>
  )
}
